import { isKeycloakAuth } from "@configs/authMode";
import { KeycloakAuthProvider } from "./KeycloakAuthProvider";
import { LegacyAuthProvider } from "./LegacyAuthProvider";

/**
 * Selects Keycloak SSO or legacy CSC login based on {@link AUTH_MODE} in env / runtime config.
 */
export function AuthProvider({ children }) {
  if (isKeycloakAuth()) {
    return <KeycloakAuthProvider>{children}</KeycloakAuthProvider>;
  }
  return <LegacyAuthProvider>{children}</LegacyAuthProvider>;
}
